import React from "react";
import { CheckIcon } from "@heroicons/react/24/outline";
import { cn } from "@/utils/utils";

interface ConfigurationStepProps {
  children?: React.ReactNode;
  description: string;
  isComplete?: boolean;
  number: number;
  title: string;
}

const ConfigurationStep: React.FC<ConfigurationStepProps> = ({
  children,
  description,
  isComplete = false,
  number,
  title,
}) => {
  return (
    <div className="flex flex-col gap-2 border-b border-dashed border-gray-200 py-5 last:border-b-0 last:pb-1 dark:border-slate-700 sm:flex-row sm:gap-4">
      <span
        className={cn(
          "flex h-7 w-7 shrink-0 items-center justify-center rounded-full border text-xs font-medium",
          isComplete
            ? "border-green-200 bg-green-100 text-green-700 dark:border-green-900 dark:bg-green-950/60 dark:text-green-400"
            : "border-gray-200 bg-white text-gray-500 dark:border-slate-600 dark:bg-slate-800 dark:text-gray-400",
        )}
      >
        {isComplete ? <CheckIcon className="h-4 w-4" /> : number}
      </span>

      <div className="min-w-0 flex-1 sm:pt-0.5">
        <h3 className="text-sm font-medium text-gray-900 dark:text-white">
          {title}
        </h3>
        <p className="mt-0.5 text-sm text-gray-500 dark:text-gray-400">
          {description}
        </p>
        {children && <div className="mt-4">{children}</div>}
      </div>
    </div>
  );
};

export default ConfigurationStep;
